import { useState } from 'react';

const AddressSearch = ({ onAddressSelect }) => {
  const [address, setAddress] = useState('');
  const [unitNumber, setUnitNumber] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchAddress = async (query) => {
    if (!query || query.length < 3) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://geosearch.planninglabs.nyc/v2/search?text=${encodeURIComponent(query)}`
      );
      const data = await response.json();
      
      // Filter for NYC addresses only
      const nycAddresses = data.features
        .filter(feature => feature.properties.borough)
        .map(feature => ({
          ...feature,
          properties: {
            ...feature.properties,
            // Standardize borough names to match your existing data
            borough: standardizeBorough(feature.properties.borough)
          }
        }));

      setSuggestions(nycAddresses);
    } catch (error) {
      console.error('Error fetching addresses:', error);
      setError('Error searching addresses. Please try again.');
    }
    setLoading(false);
  };

  const standardizeBorough = (borough) => {
    const boroughMap = {
      'Manhattan': 'Manhattan',
      'Brooklyn': 'Brooklyn',
      'Queens': 'Queens',
      'Bronx': 'The Bronx',
      'Staten Island': 'Staten Island'
    };
    return boroughMap[borough] || borough;
  };

  const handleSelect = (feature) => {
    const addressData = {
      fullAddress: unitNumber 
        ? `${feature.properties.label} Apt ${unitNumber}`
        : feature.properties.label,
      borough: feature.properties.borough,
      unit: unitNumber,
      lat: feature.geometry.coordinates[1],
      lng: feature.geometry.coordinates[0]
    };

    setAddress(feature.properties.label);
    setSuggestions([]);
    onAddressSelect(addressData);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="block text-lg font-normal text-gray-600">
          Address <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <input
            type="text"
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
              searchAddress(e.target.value);
            }}
            placeholder="Enter your NYC address"
            className="w-full px-3 py-2 border rounded-md"
          />
          {loading && (
            <div className="absolute right-3 top-2">
              <span className="text-gray-400">Loading...</span>
            </div>
          )}
          {suggestions.length > 0 && (
            <ul className="absolute z-10 w-full bg-white border rounded-md mt-1 shadow-lg max-h-60 overflow-auto">
              {suggestions.map((feature) => (
                <li
                  key={feature.properties.id}
                  onClick={() => handleSelect(feature)}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  {feature.properties.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-lg font-normal text-gray-600">
          Apartment/Unit Number
        </label>
        <input
          type="text"
          value={unitNumber}
          onChange={(e) => setUnitNumber(e.target.value)}
          placeholder="Optional (e.g., 4B, 12A)"
          className="w-full px-3 py-2 border rounded-md"
        />
      </div>

      {error && (
        <div className="text-red-500 text-sm">
          {error}
        </div>
      )}
      <div className="text-xs text-gray-500">
        Start typing to see address suggestions
      </div>
    </div>
  );
};

export default AddressSearch; 